import { createContext } from "react";

const StudentMenuContext = createContext();

export default StudentMenuContext;